'use client';

import { useState, useEffect } from 'react';

export default function CookieBanner() {
    const [showBanner, setShowBanner] = useState(false);
    const [isVisible, setIsVisible] = useState(false);
    const [language, setLanguage] = useState('ru');

    useEffect(() => {
        // Проверяем что мы в браузере
        if (typeof window === 'undefined') return;

        try {
            // Определяем язык из URL
            const path = window.location.pathname;
            const detectedLang = path.startsWith('/en') ? 'en' : 'ru';
            setLanguage(detectedLang);

            // Проверяем согласие
            const consent = localStorage.getItem('cookieConsent');
            if (!consent) {
                setShowBanner(true);
                // Добавляем небольшую задержку для плавной анимации
                setTimeout(() => setIsVisible(true), 100);
            }
        } catch (error) {
            console.warn('CookieBanner initialization error:', error);
        }
    }, []);

    const handleAccept = () => {
        try {
            if (typeof window === 'undefined') return;

            localStorage.setItem('cookieConsent', 'accepted');
            localStorage.setItem('cookieConsentDate', new Date().toISOString());
            window.dispatchEvent(new CustomEvent('cookie-consent-change', { detail: 'accepted' }));

            // Плавное скрытие
            setIsVisible(false);
            setTimeout(() => setShowBanner(false), 300);

            // Инициализируем Google Analytics только после согласия
            if (typeof window !== 'undefined' && window.gtag) {
                window.gtag('consent', 'update', {
                    'analytics_storage': 'granted'
                });
            }
        } catch (error) {
            console.warn('CookieBanner accept error:', error);
        }
    };

    const handleDecline = () => {
        try {
            if (typeof window === 'undefined') return;

            localStorage.setItem('cookieConsent', 'declined');
            localStorage.setItem('cookieConsentDate', new Date().toISOString());
            window.dispatchEvent(new CustomEvent('cookie-consent-change', { detail: 'declined' }));

            // Плавное скрытие
            setIsVisible(false);
            setTimeout(() => setShowBanner(false), 300);

            // Запрещаем аналитику
            if (typeof window !== 'undefined' && window.gtag) {
                window.gtag('consent', 'update', {
                    'analytics_storage': 'denied'
                });
            }
        } catch (error) {
            console.warn('CookieBanner decline error:', error);
        }
    };

    const content = {
        ru: {
            eyebrow: 'Конфиденциальность',
            title: 'Файлы Cookie',
            text: 'Мы используем cookie для улучшения работы сайта и персонализации контента.',
            accept: 'Принять',
            decline: 'Только необходимые',
            moreInfo: 'Подробнее',
            privacyLink: '/ru/privacy'
        },
        en: {
            eyebrow: 'Privacy',
            title: 'Cookie Settings',
            text: 'We use cookies to enhance your experience and personalize content.',
            accept: 'Accept',
            decline: 'Essential Only',
            moreInfo: 'Learn More',
            privacyLink: '/en/privacy'
        }
    };

    const t = content[language] || content.ru;

    // Не показываем ничего если баннер не нужен или мы не в браузере
    if (typeof window === 'undefined' || !showBanner) return null;

    return (
        <div className={`gf-cookie${isVisible ? ' is-visible' : ''}`}>
            <div className="gf-cookie-card">
                <button
                    type="button"
                    onClick={handleDecline}
                    className="gf-cookie-close"
                    aria-label={language === 'ru' ? 'Закрыть' : 'Close'}
                >
                    ×
                </button>
                <div className="gf-cookie-eyebrow">{t.eyebrow}</div>
                <h3 className="gf-cookie-title">{t.title}</h3>
                <p className="gf-cookie-text">
                    {t.text}{' '}
                    <a href={t.privacyLink}>{t.moreInfo}</a>
                </p>
                <div className="gf-cookie-actions">
                    <button type="button" onClick={handleDecline} className="gf-cookie-btn sec">
                        {t.decline}
                    </button>
                    <button type="button" onClick={handleAccept} className="gf-cookie-btn">
                        {t.accept}
                    </button>
                </div>
            </div>
        </div>
    );
}
